import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import Navbar from "./components/Navbar";
import GalleryPage from "./components/GalleryPage";
import PaymentPage from "./components/PaymentPage";
import ProjectsPage from "./components/ProjectsPage";
import ProjectDetailsPage from "./components/ProjectDetailsPage";
import AboutPage from "./components/AboutPage";
import ContactPage from "./components/ContactPage";
import Statistics from "./components/Statistics";
import ImageGallery from "./components/ImageGallery";
import Footer from "./components/Footer";
import { LanguageProvider, useLanguage } from "./context/LanguageContext";
import boxes from "./assets/boxes.png";

function HomePage() {
  const { t, language } = useLanguage();

  // Hebrew and English content for the story
  const storyContent = {
    he: 'אצל כל הילדים במשפחה שלנו, במסיבת הבר/בת מצווה, אנחנו עשינו "פרויקט" שכל האורחים השתתפו בו – לארוז אריזה של טובין שהגיעו למשפחות נזקקות. אותם פרויקטים המשכנו לארוז ולמסור למשפחות כל שנה מאז בר/בת מצוה לכבוד ימי הולדת של הילדים. זאת אומרת, 6 פעמים בשנה, כל שנה, אנו עושים את הפרויקטים האלה. גם מוסיפים עוד פרויקט פה ושם לכבוד שמחה אחר במשפחה. אחרי 34 שנים של פעילות רציפה, הקמנו את עמותת ארזי חסד כדי להסדיר את הנתינה מתחת לגג אחד וגם לתת לאחרים ליזום פרויקטים שלהם. החבילות המוכנות ליחידים ומשפחות מועברות לעמותות אחרות שיש להם רשת ותשתית הפצה למשפחות.',
    en: 'For all the children in our family, at their Bar/Bat Mitzvah celebrations, we organized a "project" where all guests participated – packing goods that were delivered to families in need. We continued packing and delivering these projects to families every year since then, in honor of our children\'s birthdays. This means 6 times a year, every year, we carry out these projects. We also add other projects here and there to celebrate other family occasions. After 34 years of continuous activity, we established the Arzei Chessed Association to organize our giving under one roof and to allow others to initiate their own projects. The packages prepared for individuals and families are transferred to other organizations that have distribution networks for families in need.',
  };

  return (
    <div className="page-content">
      <div className="hero-image">
        <img src={boxes} alt="Charity boxes" />
        <Statistics />
      </div>
      <div className="story-title">{t("how.it.started")}</div>
      <div className={`story-content ${language === "en" ? "english" : ""}`}>
        {storyContent[language]}
      </div>
      <div className="preview-title">{t("our.work.preview")}</div>
      <ImageGallery />
    </div>
  );
}

function AppContent() {
  const { language } = useLanguage();

  return (
    <div className="App" dir={language === "he" ? "rtl" : "ltr"}>
      <Navbar />
      <Routes>
        {/* Hebrew Routes */}
        <Route path="/" element={<HomePage />} />
        <Route path="/gallery" element={<GalleryPage />} />
        <Route path="/projects" element={<ProjectsPage />} />
        <Route path="/projects/:projectSlug" element={<ProjectDetailsPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/donate" element={<PaymentPage />} />
        <Route path="/contact" element={<ContactPage />} />

        {/* English Routes */}
        <Route path="/en" element={<HomePage />} />
        <Route path="/en/gallery" element={<GalleryPage />} />
        <Route path="/en/projects" element={<ProjectsPage />} />
        <Route
          path="/en/projects/:projectSlug"
          element={<ProjectDetailsPage />}
        />
        <Route path="/en/about" element={<AboutPage />} />
        <Route path="/en/donate" element={<PaymentPage />} />
        <Route path="/en/contact" element={<ContactPage />} />
      </Routes>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <Router>
      <LanguageProvider>
        <AppContent />
      </LanguageProvider>
    </Router>
  );
}

export default App;
